import {
  UPDATE_OFFICE_SERVER_PENDING,
  UPDATE_OFFICE_SERVER_SUCCESS,
  UPDATE_OFFICE_SERVER_ERROR,
  RESET_UPDATE_OFFICE_SERVER,
  UpdateOfficeServerState,
  UpdateOfficeServerActionType,
} from "./types";

const initialState: UpdateOfficeServerState = {
  updateOfficeServerPending: false,
  updateOfficeServerError: false,
}

export function UpdateOfficeServerReducer(
  state: UpdateOfficeServerState = initialState,
  action: UpdateOfficeServerActionType
): UpdateOfficeServerState {
  switch (action.type) {

    case UPDATE_OFFICE_SERVER_PENDING: {
      return {
        ...state,
        updateOfficeServerPending: true,
      };
    }

    case UPDATE_OFFICE_SERVER_SUCCESS: {
      return {
        ...state,
        updateOfficeServerPending: false,
        updateOfficeServerError: false,
      };
    }

    case UPDATE_OFFICE_SERVER_ERROR: {
      return {
        ...state,
        updateOfficeServerPending: false,
        updateOfficeServerError: true,
      };
    }

    case RESET_UPDATE_OFFICE_SERVER: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
